// extracted by mini-css-extract-plugin
export default {"cardWrapper":"NovostiDetaljno_cardWrapper__00le+","newsContent":"NovostiDetaljno_newsContent__72y6K"};